var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"owc-stage-cta-buttons",class:{
    'owc-stage-cta-buttons--dark': _vm.isDarkMode,
  }},[(_vm.isAutomatedDisplayMethod)?[_c('globalelem-cta-web-component',{staticClass:"owc-stage-cta-buttons__cta-wc",attrs:{"modelseries":_vm.vehicleData.scoped ? _vm.vehicleData.modelSeries : '',"subbrand":_vm.vehicleData.scoped ? _vm.vehicleData.subBrands : '',"darkmode":_vm.isDarkMode,"direction":_vm.isMobile ? 'vertical' : 'horizontal',"size":"m"}})]:_vm._l((_vm.ctas),function(cta){return _c('a',{directives:[{name:"show",rawName:"v-show",value:(!!cta.label),expression:"!!cta.label"}],key:cta.label,staticClass:"owc-stage-cta-buttons__button wb-button wb-button--medium",class:[
        {
          'wb-button--theme-dark': _vm.isDarkMode,
          'wb-button--large': !_vm.isMobile,
        },
        _vm.getCtaButtonClasses(cta),
      ],attrs:{"target":cta.target,"href":cta.url}},[_vm._v(" "+_vm._s(cta.label)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }